Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var cn = require('classnames');
var coreComponentsShared = require('../shared');
var Context = require('./Context.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var styles = {"component":"system-message__component_1kvg0","fullHeight":"system-message__fullHeight_1kvg0","first":"system-message__first_1kvg0","last":"system-message__last_1kvg0","controls":"system-message__controls_1kvg0","both":"system-message__both_1kvg0"};
require('./index.css');

var isControlsElement = function (obj) {
    return typeof obj === 'object' && obj.type.displayName === 'Controls';
};
var DEFAULT_DESKTOP_PADDING = { left: 40, right: 40, bottom: 24 };
var DEFAULT_MOBILE_PADDING = undefined;
var SystemMessage = function (_a) {
    var _b;
    var view = _a.view, dataTestId = _a.dataTestId, children = _a.children, fullHeight = _a.fullHeight, paddingProp = _a.padding, className = _a.className;
    var contextValue = React.useMemo(function () { return ({ dataTestId: dataTestId, view: view, fullHeight: fullHeight }); }, [view, dataTestId, fullHeight]);
    var renderChildrenWithFullHeight = function () {
        var renderCloned = function (child, extraClassName) {
            return React__default.default.cloneElement(child, tslib.__assign(tslib.__assign({}, child.props), { className: cn__default.default(child.props.className, extraClassName) }));
        };
        var childrenArray = React__default.default.Children.toArray(children);
        var childrenCount = childrenArray.length;
        return childrenArray.map(function (child, idx) {
            var isFirstElement = idx === 0;
            var isLastElement = idx + 1 === childrenCount;
            if (isFirstElement && React.isValidElement(child)) {
                if (isLastElement) {
                    return renderCloned(child, styles.both);
                }
                return renderCloned(child, styles.first);
            }
            if (isLastElement && React.isValidElement(child)) {
                return renderCloned(child, isControlsElement(child) ? styles.controls : styles.last);
            }
            return child;
        });
    };
    var padding = paddingProp !== null && paddingProp !== void 0 ? paddingProp : (view === 'desktop' ? DEFAULT_DESKTOP_PADDING : DEFAULT_MOBILE_PADDING);
    return (React__default.default.createElement(Context.SystemMessageContext.Provider, { value: contextValue },
        React__default.default.createElement("div", { "data-test-id": dataTestId, className: cn__default.default(styles.component, className, (_b = {},
                _b[styles.fullHeight] = fullHeight,
                _b)), style: coreComponentsShared.createPaddingStyle(padding) }, fullHeight ? renderChildrenWithFullHeight() : children)));
};

exports.SystemMessage = SystemMessage;
